// 单位地图使用
class DeliveryTask {
  colors = ['', '#28add9', '#30a94f', '#dd137b', '#974578', '#e77817', '#75c5f0', '#495677', '#8e84b7', '#71625b',
    '#ef9ba0', '#449284', '#84c225', '#e7785f', '#42929d', '#f8c300', '#7bc4a0', '#b76767', '#c4bf66', '#b74f8f',
    '#5f3a74'
  ]
  carMarker = null // 配送员位置
  distance = 0 //总距离
  list = [] //配送员送货任务列表
  last = '' //最后已完成任务路径
  //将点集合 距离文本集合 线对象存储 统一调用渲染 优化渲染速度
  markers = [] //任务点集合 用于聚焦
  disText = [] //距离集合 用于重绘
  taskPath = [] //配送员已完成任务路径
  trackPath = [] //配送员实际路径
  taskPolylineShow = false
  trackPolylineShow = false
  disTextShow = false
  dataDate = '' // 路径日期
  dateTimes = []
  polylineTime = 0 //重新设置线条时 防抖处理

  labelIcon = '' // LabelMarker的icon 用于温湿度点显示
  labelsLayer = null
  msgMarker = null
  humiturePolyline = null
  humitureMassMarkers = []

  constructor({
    context,
    uid,
    name,
    username,
    style,
    start,
    map,
    call
  }) {
    this.context = context;
    this.map = map;
    this.uid = uid; //配送员uid
    this.name = name; //配送员名称
    this.username = username;
    this.style = style; //该配送员图标样式 线条样式
    this.style2 = style + 20;
    this.color = this.colors[this.style];
    this.start = start; //配送公司起始位置
    this.call = call;
    this.labelIcon = context.$config.url + '/manager/static/map/circle-green.png';

    this.taskPolyline = new AMap.Polyline({
      path: [],
      isOutline: true,
      outlineColor: 'white',
      showDir: true,
      strokeColor: this.color, // 线颜色
      strokeWeight: 6, // 线宽
      zIndex: 11,
      lineCap: 'round',
      lineJoin: 'round'
    }); //任务线路 非实际线路

    this.trackPolyline = new AMap.Polyline({
      path: [],
      isOutline: true,
      outlineColor: this.color,
      showDir: true,
      strokeColor: '#ff5555', // 线颜色
      strokeWeight: 6, // 线宽
      zIndex: 12,
      lineCap: 'round',
      lineJoin: 'round'
    }); //实际路径线路
  }
  // 是否完成送货任务 及 路径点=任务数量
  get isCompleted() {
    return this.list.length == this.completed
  }
  //完成任务数量
  get completed() {
    return this.list.filter(item => item.send_time).length
  }
  // 获取送货员今天所在位置
  getLocation() {
    return new Promise((resolve) => {
      this.context.request({
        url: '/admin/user/get_info',
        is_public: true,
        data: {
          delivery_uid: this.uid
        },
        complete: res => {
          if (res.error_code == 0) {
            if (res.data.lng && res.data.lat) {
              this.setCarMarker(res.data.lng, res.data.lat)
            } else {
              this.removeCarMarker()
            }
          }
          resolve()
        }
      })
    })
  }
  // 获取送货员实际路径
  getPolyline(date) {
    return new Promise((resolve) => {
      if (this.dataDate == date) {
        this.initPolyline('trackPath')
        resolve()
        return
      }
      this.dataDate = date;
      this.context.request({
        url: '/admin/delivery/get_delivery_trace',
        is_public: true,
        data: {
          user_id: this.uid,
          day: date
        },
        complete: res => {
          if (res.error_code == 0) {
            let lineArr = res.data.reduce((arr, item) => {
              arr.push([item.lng, item.lat])
              return arr
            }, []);
            if (lineArr.length) {
              this.trackPath = lineArr;
              this.initPolyline('trackPath')
            }
          }
          resolve()
        }
      })
    })
  }
  // 添加司机位置
  setCarMarker(lng, lat) {
    if (this.carMarker) {
      this.map.remove(this.carMarker)
    }
    let carPos = new AMap.LngLat(lng, lat);
    this.carMarker = new AMap.Marker({
      title: this.name,
      position: carPos,
      offset: new AMap.Pixel(-13, -26),
      zIndex: 120,
      icon: "https://a.amap.com/jsapi_demos/static/demo-center-v2/car.png"
    });
    this.carMarker.setLabel({
      direction: 'top',
      offset: new AMap.Pixel(10, 0), //设置文本标注偏移量
      content: `<div style="">${this.name}</div>`, //设置文本标注内容
    });
    this.map.add(this.carMarker)
  }
  //移除司机位置
  removeCarMarker() {
    if (this.carMarker) {
      this.map.remove(this.carMarker)
      this.carMarker = null;
    }
  }
  //添加任务数据
  addList(item) {
    item.style = this.style;
    if (item.status == 2) {
      item.style = this.style2;
      if (!this.last || this.last.send_time < item.send_time) {
        // 如果状态完成且 与 记录中最后完成数据时间 对比后 更晚 则更新最后完成数据
        this.last = item;
      }
    }
    this.list.push(item)
    this.markers.push(item.marker)
  }
  //按照送货时间排序 外部使用
  sortList() {
    this.list.sort((a, b) => a.send_time < b.send_time ? -1 : 1);
    // 循环连线并记录距离
    this.list.forEach(itm => {
      if (itm.status == 2) {
        this.addPath([itm.lng, itm.lat]);
      }
    });
  }
  //更新 连线 距离 缓存  用于外部调用更新数据
  update(data) {
    let obj = this.list.find(item => item.id == data.id)
    if (data.status == 2 && obj && obj.status != 2) {
      obj.status = 2;
      obj.send_time = data.send_time;
      obj.style = this.style2; //点样式更新

      this.addPath([obj.lng, obj.lat])
      this.initPolyline('taskPath')

      this.call && this.call({
        type: 'addDisText',
        data: this.disText[this.disText.length - 1]
      })
    }
  }
  //添加已完成任务坐标 用于绘制完成线路
  addPath(path) {
    let lastPath = this.taskPath.length ? this.taskPath[this.taskPath.length - 1] : this.start;
    let m1 = new AMap.Marker({
      position: new AMap.LngLat(lastPath[0], lastPath[1]),
    });
    let m2 = new AMap.Marker({
      position: new AMap.LngLat(path[0], path[1]),
    });
    //计算点距离 并缓存至距离文本集合
    this.computeDis(m1, m2);
    //添加坐标放入绘制路径
    this.taskPath.push(path);
    this.initPolyline('taskPath')
  }
  //防止重复多次绘制路径
  initPolyline(name) {
    let path = [];
    if (name == 'taskPath') {
      path = [this.start, ...this.taskPath];
    } else {
      path = this.trackPath;
    }
    clearTimeout(this.polylineTime)
    this.polylineTime = setTimeout(() => {
      if (name == 'taskPath') {
        this.taskPolyline.setPath(this.getCopyPath(path))
      } else {
        this.trackPolyline.setPath(this.getCopyPath(path))
      }
    }, 100)
  }
  //重新设置 连线 距离 并改变视野范围
  initShow(isDisText = false, isTask = false, isTrack = false) {
    this.toggleShow('disText', isDisText && isTask)
    this.toggleShow('taskPolyline', isTask)
    this.toggleShow('trackPolyline', isTrack)
  }
  //切换路径显示隐藏 name=taskPolyline任务线路 trackPolyline实际路径 disText务线路距离
  toggleShow(name, toggle) {
    if (this[name]) {
      let type = 'add';
      if (toggle != undefined) {
        !toggle && (type = 'remove')
        if ((this[name + 'show'] && toggle) || (!this[name + 'show'] && !toggle)) {
          return
        }
      } else if (this[name + 'show']) {
        type = 'remove'
      }
      this[name + 'show'] = type == 'add';
      this.map[type](this[name])
    }
  }
  //复制数据
  getCopyPath(data) {
    return JSON.parse(JSON.stringify(data));
  }
  //计算点点之间距离
  computeDis(m1, m2) {
    let p1 = m1.getPosition();
    let p2 = m2.getPosition();
    let textPos = p1.divideBy(2).add(p2.divideBy(2));
    let distance = Math.round(p1.distance(p2));
    this.distance += distance;
    let text = new AMap.Text({
      text: `相距${distance}米`,
      position: textPos,
      zIndex: 10,
      style: {
        'background-color': this.color,
        'border-color': '#e1f5fe',
        'font-size': '12px'
      }
    });
    //缓存距离文本
    this.disText.push(text);
  }
  //显示温湿度点和路径图层
  toggleShowHumiture(times, show = true) {
    this.dateTimes = times;
    this.humiturePolyline && this.map.remove(this.humiturePolyline);
    this.labelsLayer && this.map.remove(this.labelsLayer);

    if (!show) {
      return
    }

    this.labelsLayer = new AMap.LabelsLayer({
      zooms: [3, 20],
      zIndex: 190,
      collision: false,
    }); //图层 温湿度点和路径图层
    this.map.add(this.labelsLayer);

    this.getHumitureList().then(() => {
      this.map.add(this.humiturePolyline); //添加线
      this.labelsLayer.add(this.humitureMassMarkers); //添加点集合
      this.context.$nextTick(() => {
        this.map.setFitView(this.humitureMassMarkers, true);
      });
    })
  }
  //获取温湿度数据
  getHumitureList() {
    return new Promise((resolve) => {
      this.context.request({
        url: '/admin/delivery/get_delivery_sense_trace',
        is_public: true,
        data: {
          user_id: this.uid,
          start_time: this.dateTimes[0],
          end_time: this.dateTimes[1],
        },
        complete: async (res) => {
          if (res.error_code == 0) {
            if (!this.msgMarker) {
              this.msgMarker = new AMap.Marker({
                anchor: 'bottom-center',
                content: " ",
                map: this.map,
                offset: new AMap.Pixel(0, -15),
                zIndex: 160
              });
            }
            let icon = {
              type: 'image',
              image: this.labelIcon,
              size: [15, 15],
              anchor: 'center',
            };
            let humitureMassMarkers = [];
            let humiturePolylineList = [];
            let list = res.data;
            for (let i = 0; i < list.length; i++) {
              let item = list[i];
              let lnglat = [item.data.lng, item.data.lat];
              humiturePolylineList.push(lnglat)
              let labelMarker = new AMap.LabelMarker({
                extData: item,
                position: lnglat,
                icon: icon
              });
              let that = this;
              // 给marker绑定事件
              labelMarker.on('mouseover', function(e) {
                let position = e.data.data && e.data.data.position;
                if (position) {
                  let extData = this.getExtData();
                  that.msgMarker.setPosition(position);
                  that.msgMarker.setContent(`<div class="normalMarker_content">
                    <div class="normalMarker_title">车辆状态</div>
                    <div class="normalMarker_tip">时间：${new Date(extData.time*1000).format('M-D hh:mm:ss')}</div>
                    <div class="normalMarker_tip">设备：${extData.device_sn}</div>
                    <div class="normalMarker_tip">温度：${extData.data.t||'-'}℃</div>
                    <div class="normalMarker_tip">湿度：${extData.data.h||''}%RH</div>
                  </div>`);
                  that.map.add(that.msgMarker);
                }
              });
              labelMarker.on('mouseout', () => {
                that.map.remove(that.msgMarker);
              });
              humitureMassMarkers.push(labelMarker)
            }
            this.humitureMassMarkers = humitureMassMarkers;
            this.humiturePolyline = new AMap.Polyline({
              path: humiturePolylineList,
              isOutline: true,
              outlineColor: 'white',
              showDir: true,
              strokeColor: this.color, // 线颜色
              strokeWeight: 6, // 线宽
              zIndex: 11,
              lineCap: 'round',
              lineJoin: 'round'
            }); //任务线路 非实际线路
            resolve()
          }
        }
      })
    })
  }
  // 坐标转换
  AMapConvertFrom(lnglat, type = 'baidu') {
    return new Promise((resolve) => {
      if (lnglat && lnglat[0] && lnglat[1]) {
        AMap.convertFrom(lnglat, type, function(status, result) {
          if (result.info === 'ok' && result.locations.length) {
            let obj = result.locations[0];
            resolve([obj.lng, obj.lat])
          } else {
            resolve(lnglat)
          }
        });
      } else {
        resolve(lnglat)
      }
    })
  }
}
window.DeliveryTask = DeliveryTask;

/**
 * el-select 的远程搜索功能
 * @visible-change 展开收缩触发
 * popper-class 对应值与v-selectLoad:后拼接值一致 分页滚动加载功能 需要配合v-selectLoad自定义指令使用
 * remote remote-method 远程模糊搜索
  <el-select class="page_form_width" :placeholder="$ts('商品名称')" v-model="searchList.goods_id" clearable
    filterable :remote="selectRemote.isSearch" :remote-method="selectRemote.search.bind(selectRemote)"
    v-selectLoad:className="selectRemote.getList.bind(selectRemote)" popper-class="className"
    @visible-change="selectRemote.visibleChange()" :loading="selectRemote.loading">
    <el-option v-for="(item , index) in selectRemote.list" :key="item.id" :value="item.id" :label="item.title" />
    <el-option :label="selectRemote.moreText" value="-2" disabled v-show="selectRemote.moreShow" />
  </el-select>

  自定义指令
  selectLoad = {
    bind(el, binding) {
      const selectScroll = el.querySelector(`.${binding.arg} .el-select-dropdown__wrap`);
      if (selectScroll) {
        selectScroll.addEventListener('scroll', function() {
          const condition = this.scrollHeight - this.scrollTop.toFixed(0) <= this.clientHeight + 34;
          if (condition) binding.value()
        })
      }
    },
    unbind(el, binding) {
      const selectScroll = el.querySelector(`.${binding.arg}`);
      selectScroll && selectScroll.remove()
    },
  }
 */
export class SelectRemote {
  loading = false;
  url = ''; //列表接口
  page = 1; //分页
  limit = 50; //每页数量显示
  params = {};
  more = 'more'; //加载状态
  list = []; // 列表
  timeout = 0; //延时器
  searchText = ''; //搜索内容
  searchKey = 'title'; //接口搜索内容的key
  isSearch = true; //是否为搜索
  listKey = 'data'; //列表数据所在key
  noMore = false; //加载
  context = null; //this
  constructor(data = {}) {
    for (let key in data) {
      if (data.hasOwnProperty(key)) {
        this[key] = data[key]
      }
    }
  }
  get moreShow() {
    return this.more != 'more' && !this.noMore;
  }
  get moreText() {
    return this.more == 'noMore' ? this.context.$ts('没有更多了') : this.context.$ts('加载中');
  }
  visibleChange() {
    if (this.list.length == 0) {
      this.search()
    }
  }
  search(query = '') {
    if (query) {
      this.searchText = query;
    }
    this.initList()
  }
  initList() {
    this.loading = false;
    this.more = 'more';
    this.page = 1;
    this.list = [];
    this.getList()
  }
  getList() {
    if (this.moreShow || this.loading) {
      return
    }
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
    let params = {
      ...this.params,
      limit: this.limit,
      page: this.page,
    }
    if (this.isSearch) {
      params[this.searchKey] = this.searchText;
    }
    this.before && this.before()
    if (params.page == 1) {
      this.loading = true;
    } else {
      this.more = 'loading';
    }
    this.timeout = setTimeout(() => {
      this.timeout = 0;
      this.context.request({
        url: this.url,
        data: params,
        is_public: true,
        complete: (res) => {
          if (res.error_code == 0) {
            if (!this.isSearch || this.searchText == params[this.searchKey]) {
              let list = res.data;
              if (this.listKey) {
                list = list[this.listKey];
              }
              this.after && this.after(list)
              if (list.length < this.limit) {
                this.more = 'noMore';
              } else {
                this.more = 'more';
                this.page++;
              }
              this.list = this.list.concat(list);
              this.loading = false;
            }
          } else {
            this.more = 'noMore';
            this.loading = false;
            if (res.error_msg) {
              this.context.$message.error(res.error_msg)
            }
          }
        }
      })
    }, 500)
  }
}
window.SelectRemote = SelectRemote;

/**
 * 分页
 * <el-pagination @size-change="PaginationCache.sizeChange($event)" @current-change="PaginationCache.currentChange($event)"
    :layout="PaginationCache.layout" :page-sizes="PaginationCache.pageSizes" :page-size="PaginationCache.limit"
    :current-page="PaginationCache.page" :total="PaginationCache.total" />
 *
*/
export class PaginationCache {
  type = ''; // scroll滚动加载
  refName = 'tableData';
  more = 'more';
  loading2 = false;
  initParams = '{}'
  params = {}; //提交数据
  paramsJson = '{}'; //提交数据
  url = ''; //列表接口
  page = 1; //分页
  limit = 20; //每页数量显示
  total = 0; //合计数据数量
  pageSizes = [10, 20, 50, 100, 200]; //每页可选数量
  layout = "total, sizes, prev, pager, next, jumper";
  rowKey = 'id';
  list = [];
  selection = [];
  timer = 0;
  context = null
  lastData = {}
  before = null
  after = null
  saveScrollTop = 0 //保存的滚动位置
  scrollTime = null //防抖时间
  scrollSave = false //是否回滚
  tableBodyWrapper = null
  refFormName = ''
  formHeight = 0 //计算表格展开高度 用于折叠
  isFold = false //切换页面折叠

  constructor(data = {}) {
    for (let key in data) {
      if (data.hasOwnProperty(key)) {
        this[key] = data[key]
      }
    }
    this.initParams = JSON.stringify(this.params)

    this.context.$nextTick(() => {
      this.initFormHeight()
    })
  }
  get loading() {
    return this.more == 'loading' || this.loading2;
  }
  get nums() {
    return this.selection.length;
  }
  get totalStr() {
    return this.nums ? `(${this.nums})` : '';
  }
  get isShowFold() {
    return this.formHeight / 2 > 40
  }

  initFormHeight() {
    this.formHeight = this.refFormName ? this.context.$refs[this.refFormName].$el.clientHeight : 0;
  }

  toggleFold() {
    this.isFold = !this.isFold
  }

  /**
   * 选中数据更改 @selection-change = ""  PaginationCache.selectionChange
   * :row-key="PaginationCache.rowKey"+:reserve-selection="true"使用
   * */
  selectionChange(selection, row) {
    this.selection = selection;
  }
  // 清空某项或所有
  clearSelection(row) {
    if (row && row[this.rowKey]) {
      this.context.$refs[this.refName].toggleRowSelection(row, false)
    } else {
      this.context.$refs[this.refName].clearSelection()
    }
  }
  // 每页数量更改
  sizeChange(limit = 20) {
    this.page = 1;
    this.limit = limit;
    this.list = [];
    this.initList()
  }
  // 分页更改
  currentChange(page) {
    this.page = page;
    this.list = [];
    this.getList()
  }
  initData() {
    this.page = 1;
    this.total = 0;
    this.list = [];
    this.selection = [];
    this.more = 'more';
    this.params = JSON.parse(this.initParams);
  }
  // 初始获取
  initList(param) {
    this.more = 'more';
    this.page = 1;
    this.list = [];
    this.scrollSave = param == 1; // 是否回滚
    this.paramsJson = JSON.stringify(this.params);
    this.context.beforeList && this.context.beforeList()
    if (!this.tableBodyWrapper && this.refName && this.context.$refs[this.refName]) {
      this.tableBodyWrapper = this.context.$refs[this.refName].bodyWrapper;
      this.tableBodyWrapper && this.tableBodyWrapper.addEventListener('scroll', () => {
        this.initTableScroll()
      })
    }
    this.getList()
  }
  //监听滚动记录位置 防抖处理
  initTableScroll() {
    if (this.scrollTime) {
      clearTimeout(this.scrollTime)
    }
    this.scrollTime = setTimeout(() => {
      this.saveScrollTop = this.tableBodyWrapper.scrollTop;
    }, 300)
  }
  // 表格回滚
  setScroll(isScr = false) {
    if (this.tableBodyWrapper) {
      this.$nextTick(() => {
        if (this.scrollSave) {
          this.tableBodyWrapper.scrollTop = this.saveScrollTop;
          if (!isScr) {
            this.scrollSave = false;
          }
        } else {
          this.tableBodyWrapper.scrollTop = 0;
        }
      })
    }
  }
  // 获取列表
  getList(downType) {
    if (this.more != 'more' && !downType) {
      return
    }
    let nowMore = this.more;
    this.more = 'loading';
    clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      let params = JSON.parse(this.paramsJson);
      for (let key in params) {
        this.params[key] = params[key];
      }
      params.page = this.page;
      params.limit = this.limit;
      if (downType) {
        params.task_type = downType;
      }
      let isReturn = false;
      this.before && this.before(params, (isRet) => {
        isReturn = isRet;
      })
      if (isReturn) {
        return
      }
      this.context.request({
        url: this.url,
        data: params,
        is_public: true,
        complete: res => {
          if (res.error_code == 0) {
            if (params.task_type) {
              this.more = nowMore;
              this.context.$message.success(this.context.$ts('正在创建导出任务，完成后即可在右侧窗口下载'));
              this.context.$emit('downloading')
              return
            }
            res.params = params;
            let list = res.data.data;
            this.after && this.after(res, (newList) => {
              list = newList;
            }, this.type)
            this.total = res.data.total;
            this.lastData = res.data;
            if (this.type == 'scroll') {
              this.list = this.list.concat(list);
              if (list.length < params.limit) {
                this.more = 'noMore'
              } else {
                this.more = 'more'
                this.page++
              }
            } else {
              this.more = 'more'
              this.list = list;
              this.setScroll()
            }
          } else {
            if (this.type == 'scroll') {
              this.more = 'noMore'
            } else {
              this.more = 'more'
            }
            this.context.$message.error(res.error_msg)
          }
        }
      })
    }, 300)

  }
}
window.PaginationCache = PaginationCache;



// WEBPACK FOOTER //
// ./src/assets/js/class.js